import { cn } from "@/lib/utils";

/**
 * The Sigalmark hexagon.
 *
 * Painted as a CSS mask rather than an <img> so the single olive-on-transparent
 * asset can render in ANY colour: the mask takes the artwork's alpha and fills
 * it with `currentColor`. That is what lets the same file sit on the olive
 * sidebar (white) and on a light page (olive) without shipping colour variants
 * — and it is why the sidebar previously fell back to a tenant's logo instead.
 *
 * Colour it with a normal text utility, e.g. `text-accent-foreground`.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <span
      role="img"
      aria-label="Sigalmark"
      className={cn("inline-block shrink-0 bg-current", className)}
      style={{
        WebkitMaskImage: "url(/logo__theme_standard.png)",
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        WebkitMaskSize: "contain",
        maskImage: "url(/logo__theme_standard.png)",
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
      }}
    />
  );
}
